export default "__VITE_ASSET__CVTQM$Ku__"